var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.classname!=undefined?'svgClass '+_vm.classname:'svgClass',attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('use',{attrs:{"xlink:href":'#'+_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }